
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component
export default class EmptyContent extends Vue {
  // @Prop()
  // category?: any;
}
